export default function Spinner() {
  return (
    <div>
      {" "}
      <div className="spinner-border" role="status"></div>{" "}
      <span>Cargando tareas</span>{" "}
    </div>
  );
}
